var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard"},_vm._l((_vm.leaderboard.data),function(entry,index){return _c('LeaderboardEntry',_vm._b({key:index},'LeaderboardEntry',entry[0],false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }